/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { configureSubSkillFormData } from "./config/ConfigureSkillCategory.data";
import FormCreator from "../../../../components/FinalForms/FormCreator";
import Buttons from "../../../../components/ui/button/Buttons";
import { useAddJobSubSkillMutation, useLazyGetAllSubSkillByMainSkillIdQuery } from "../../../../app/services/skillCategoriesAPI";
import { setDropDownOptionField } from "../../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { onResetForm } from "../../../../utils/FormFields/ResetForm/handleResetForm";
import ToastService from "../../../../services/toastService/ToastService";

const ConfigureSubSkill = ({ subSkillRef, positionAppliedId, onClose ,refreshGrid}) => {
    const ref = useRef();
    const [formData, setFormData] = useState(configureSubSkillFormData);
    const [mainSkilId, setMainSkillId] = useState(0)
    const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);
    const [getAllSubSkillByMainSkillId, { isFetching: isGetAllSubSkillByMainSkillIdFetching, isSuccess: isGetAllSubSkillByMainSkillIdSuccess, data: isGetAllSubSkillByMainSkillIdData, }] = useLazyGetAllSubSkillByMainSkillIdQuery();
    const [addJobSubSkill, { isLoading: isAddJobSubSkillLoading, isSuccess: isAddJobSubSkillSuccess, data: isAddJobSubSkillData }] = useAddJobSubSkillMutation();

    useEffect(() => {
        if (!isGetAllSubSkillByMainSkillIdFetching && isGetAllSubSkillByMainSkillIdSuccess && isGetAllSubSkillByMainSkillIdData) {
            setDropDownOptionField(isGetAllSubSkillByMainSkillIdData, "subSkillId", "subSkillName", formData, "subSkillId");
            setShouldRerenderFormCreator((prevState) => !prevState);
        }
    }, [isGetAllSubSkillByMainSkillIdFetching, isGetAllSubSkillByMainSkillIdSuccess, isGetAllSubSkillByMainSkillIdData, formData]);


    const getSubSkillCategoryId = (id) => {

        getAllSubSkillByMainSkillId(id)
        setMainSkillId(id);
    }

    useImperativeHandle(subSkillRef, () => ({
        getSubSkillCategoryId
    }));
    const handleAddSubSkillClick = () => {

        let subSkillForm = ref.current.getFormData()
        if (subSkillForm) {
            const request = {
                mainSkillId: mainSkilId,
                positionAppliedId: positionAppliedId,
                subSkillId: subSkillForm.subSkillId.join(','),
                isSubSkillRequired: subSkillForm.isSubSkillRequired,
            }
            addJobSubSkill(request);
        }
    }

    useEffect(() => {
        if (isAddJobSubSkillSuccess && isAddJobSubSkillData) {
            if (isAddJobSubSkillData.errorMessage?.includes("exists")) {
                ToastService.warning(isAddJobSubSkillData.errorMessage);
                return;
              }
            onClose();
            onResetForm(configureSubSkillFormData, setFormData, null)
            refreshGrid();
            ToastService.success(isAddJobSubSkillData.errorMessage);
        }
    }, [isAddJobSubSkillSuccess && isAddJobSubSkillData])

    return (<div className="mt-3">
        <form>
            <div className="row">
                <FormCreator
                    config={formData}
                    ref={ref}
                    {...formData}
                    key={shouldRerenderFormCreator}
                />
            </div>
        </form>
        <div className="row mt-3">
            <div className="col-12">
                <div className="form-btn d-flex justify-content-end">
                    <Buttons
                        buttonTypeClassName="btn dark-btn"
                        onClick={onClose}
                        buttonText="Cancel"
                    />
                    <Buttons
                        buttonTypeClassName="btn theme-btn ml-5"
                        onClick={handleAddSubSkillClick}
                        buttonText="Add"
                        isLoading={isAddJobSubSkillLoading}

                    />
                </div>
            </div>
        </div>
    </div>)
}
export default ConfigureSubSkill;